export class MenuIcons {
  static routeIcons = {
    'Admin': 'admin_panel_settings',
    'Check-In': 'fact_check',
    'Client': 'person',
    'Invoice': 'description',
    'Ledger': 'table_view',
    'Network': 'wifi',
    'Payments': 'attach_money',
    'Prospects': 'account_box',
    'Reports': 'list',
    'Resource': 'meeting_room',
    'Scheduler': 'today',
    'Settings': 'settings'
  };
}